// React
import React from 'react'; // , { useState, useContext }

// Material UI
import {
    Button
  } from '@material-ui/core';

// Styles
import styles from './VersionControlActions.module.scss';

// Third party
import PropTypes from 'prop-types';

// Shared
import eventBus from '../../../shared/eventBus';

// Context
// import { DetailContext } from '../../../contexts/detail';

export default function VersionControlActions({
    id,
    rowIndex,
    versionData
  }) {

    const handleClick = (event) => {

        event.preventDefault();
        event.stopPropagation();

        if(typeof versionData !== 'undefined' && versionData !== null) {

            // if the version data is price related
            // then we will trigger the price update event
            if((typeof versionData.price !== 'undefined' && versionData.price !== null) || (typeof versionData.retailerNet !== 'undefined' && versionData.retailerNet !== null)) {
              eventBus.dispatch('priceVersionRestored_init', {
                versionData: versionData
              });
            }
            
            // if the version data is the description
            // then we will trigger that update event
            if(typeof versionData.translations !== 'undefined' && versionData.translations !== null) {
              eventBus.dispatch('dataVersionRestored_init', {
                  versionData: versionData
              });
            }
            
        }

    }

    let actionLabel = 'Restore this version';
    let actionClass = 'version-data-table-item-cta';
    const isCurrentItem = rowIndex === 0;
    if(isCurrentItem) 
    {
        actionLabel = 'Current Version';
        actionClass += '-current';
    } 
    
    return(
        <>
        <Button
          color="primary"
          className={styles[actionClass]}
          disabled={isCurrentItem}
          onClick={handleClick}>
            {actionLabel}
        </Button>
        </>
    );


  };


  // Properties
  VersionControlActions.propTypes = {
    id: PropTypes.number.isRequired,
    rowIndex: PropTypes.number.isRequired
  };